// =====================================
//
//   複合商品 相關功能 Service
//   Author: Gray
//   createtime: 2016 / 03 / 24
//   updatetime: 2016 / 03 / 24
//
// =====================================

window.InifECShared.factory("ComplexPdtService", ['$q', '$http', function($q, $http) {

    var factory = {};

    // --------------------------------
    // 取得複合商品群組
    // --------------------------------
    var getComplexPdtMap = function(complexid) {

        if(factory.complexCache[complexid]) {
            return factory.complexCache[complexid].promise;
        }

        factory.complexCache[complexid] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ComplexPdtAction.do",
            method: "GET",
            params: {
                op: "getComplexPdtMap",
                complexid: complexid,
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.complexCache[complexid].reject(data.error);
            } else {
                factory.complexCache[complexid].resolve(data);
            }            
        }).error(function (data, status, headers, config){
            factory.complexCache[complexid].reject(data);
            console.error("[InifEC Error] : ComplexPdtService.getComplexPdtMap request error.");
            console.error("status : " + status);
        });

        return factory.complexCache[complexid].promise;
    }

    /*==========================
        Members
    ==========================*/
    // 複合商品
    factory.complexCache = {};

    /*==========================
        Methods
    ==========================*/
    factory.getComplexPdtMap = getComplexPdtMap; // 取得複合商品群組

    return factory;
}]);